import React from 'react'
import './toast.css'
import NewPortal from '../newPortal/newPortal.js'
import {ScollPostion} from '../../util.js'
class ToastBar extends React.Component{

	constructor(props){
		super(props)
		this.state = {
			visible: false,
			isOkShow:false

		}
		//this.iTop = this.props.iTop

		this.handleClose = this.handleClose.bind(this)
		this.handleSure = this.handleSure.bind(this)
		this.onOff = true
    }
	componentDidMount() {

		this.setState({
			visible: this.props.visible,
			
		})
		this.handleTransform()
	}
	componentWillReceiveProps(props) {
		
		if(this.props.num!=3){
			this.setState({
				visible: props.visible,
		
			})
		}
		
	}
    handleClose(){
    	const {ToastBarClose} = this.props.ToastBarClose?this.props.ToastBarClose:''
    	this.setState({
			visible: false
    	})

		 this.props.ToastBarClose&& this.props.ToastBarClose('1')
		
    }
    handleSure(){
    	const {ToastBarSure} = this.props.ToastBarSure?this.props.ToastBarSure:''
    	this.setState({
			visible: false
    	})
		ToastBarSure&&ToastBarSure()
    }
	handleTransform(){
		var iW = document.documentElement.clientWidth
		if(iW<600){
			this.onOff = false
			var iscale = iW/600
			return 'scale('+iscale+')'
			
		}
		
		
	}
    render(){
		// 获取窗口宽度，如果大于640，弹框固定定位展示
		const iW = document.documentElement.clientWidth;
    	const {visible} = this.state
    	const {title,children,isOkShow,iTop} = this.props
    	var  iStyle = {}    		   	
    	if(this.onOff){
			iStyle={
				top:this.props.iTop
			}
    	}else{
    		if(this.props.itype){
    			iStyle = {
		    		transform:this.handleTransform(),
		    		top:this.props.iTop
    			}
    			
    		}else{
    			iStyle = {
		    		transform:this.handleTransform(),
		    		top:parseInt(this.props.iTop)-300+'px'
    			}
    		}
    		
    	}
		return (
			<NewPortal visible={visible}>
				<div style={iW > 640 ? {} : iStyle} className="toastBar-box" >

					<span className="set-borTop"></span>
					<span className="set-borTop"></span>

					<header>
						<strong className="strong1">{title}</strong>	
						<span className="close" onClick={this.handleClose}></span>
					</header>
					
					{
						typeof(children)=='string'?
							<div className="content" dangerouslySetInnerHTML={{ __html: children}}></div>:
							<div className="content" >{children}</div>								
					
					}	
					
			
					{isOkShow&&<button onClick={this.handleSure} >确定</button>}
				</div>
				<div className="toastBar-mask"></div>
			</NewPortal>
		)

    }

}
export default ToastBar


// WEBPACK FOOTER //
// ./src/component/toast/toast.js